export function normalizeText(text: string) {
  const normalizeText = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

  return normalizeText
}
